import api from '../../api';
import AWS from 'aws-sdk';
import env from '../../.env';
import asyncForEach from '../../utils/asyncForEach';

const state = {
  org: {},
  all_orgs: [],
};

const getters = {
  org(state) {
    return state.org;
  },
  all_orgs(state) {
    return state.all_orgs;
  },
};

const mutations = {
  setOrg(state, payload) {
    state.org = payload;
  },
  setAllOrgs(state, payload) {
    state.all_orgs = payload;
    payload.map(org => {
      if (org.id === state.org.id) state.org = org;
    });
  },
};

const actions = {
  setOrg(context, payload) {
    context.commit('setOrg', payload);
  },
  getAllOrgs(context) {
    return new Promise(async (resolve, reject) => {
      try {
        const orgs = await api.getOrgs();
        context.commit('setAllOrgs', orgs.organizations);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  createOrg(context, { org, file, categories, savingsTypes, organizationIdps }) {
    return new Promise(async (resolve, reject) => {
      try {
        if (file) {
          org.logoUrl = await context.dispatch('uploadFile', {
            file,
            org,
          });
        } else {
          org.logoUrl =
            'https://s3.eu-west-2.amazonaws.com/acada-web-images/logo.svg';
        }

        const saved_org = await api.createOrg({ organizations: [org] });
        const org_id = saved_org.data.createdOrganizations[0].id;

        if (categories && categories.length) {
          categories.forEach(cat => {
            cat.organizationId = org_id;
          });
          await api.createOrg({ categories });
        }

        if(savingsTypes && savingsTypes.length) {
          savingsTypes.forEach(savingsType => {
            savingsType.organizationId = org_id;
          });
          await api.createOrg({ savingsTypes });
        }

        if(organizationIdps && organizationIdps.length) {
          organizationIdps.forEach(organizationIdp => {
            organizationIdp.organizationId = org_id;
          });
          await api.createOrg({ organizationIdps });
        }

        await context.dispatch('getAllOrgs');
        await context.dispatch('getCurrencies');
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  updateOrg(
    context,
    { org, file, categories, savingsTypes, organizationIdps }
  ) {
    return new Promise(async (resolve, reject) => {
      try {
        if (file) {
          org.logoUrl = await context.dispatch('uploadFile', {
            file,
            org,
          });
        }

        const organization = {
          id: org.id,
          orgName: org.orgName,
          logoUrl: org.logoUrl,
          fy_month: org.fy_month,
          prefix: org.prefix,
          currencyId: org.currencyId,
        };

        await api.updateOrg({ organization });

        const the_org = context.getters.all_orgs.find(o => o.id === org.id);
        const existing_cat_ids = the_org.categories.map(cat => cat.id);
        const updated_cat_ids = categories.map(cat => cat.id);

        const new_cats = categories
          .filter(cat => !cat.id)
          .map(cat => {
            return {
              name: cat.name,
              organizationId: org.id,
            };
          });

        const updated_cats = categories
          .filter(cat => cat.id)
          .map(cat => {
            return {
              name: cat.name,
              organizationId: org.id,
              id: cat.id,
            };
          });

        const deleted_cats = existing_cat_ids.filter(
          id => !updated_cat_ids.includes(id)
        );

        if (new_cats.length) {
          await api.createOrg({ categories: new_cats });
        }

        if (updated_cats.length) {
          await asyncForEach(updated_cats, async category => {
            await api.updateOrg({ category });
          });
        }

        if (deleted_cats.length) {
          await api.deleteOrg({ categories: deleted_cats });
        }

        const existing_savingsType_ids = the_org.savingsTypes.map(
          savingsType => savingsType.id
        );
        const updated_savingsType_ids = savingsTypes.map(
          savingsType => savingsType.id
        );

        const new_savingsTypes = savingsTypes
          .filter(savingsType => !savingsType.id)
          .map(savingsType => {
            return {
              name: savingsType.name,
              organizationId: org.id,
            };
          });

        const updated_savingsTypes = savingsTypes
          .filter(savingsType => savingsType.id)
          .map(savingsType => {
            return {
              name: savingsType.name,
              organizationId: org.id,
              id: savingsType.id,
            };
          });

        const deleted_savingsTypes = existing_savingsType_ids.filter(
          id => !updated_savingsType_ids.includes(id)
        );

        if (new_savingsTypes.length) {
          await api.createOrg({ savingsTypes: new_savingsTypes });
        }

        if (updated_savingsTypes.length) {
          await asyncForEach(updated_savingsTypes, async savingsType => {
            await api.updateOrg({ savingsType });
          });
        }

        if (deleted_savingsTypes.length) {
          await api.deleteOrg({ savingsTypes: deleted_savingsTypes });
        }

        const existing_provider_ids = the_org.organizationIdps.map(
          provider => provider.id
        );
        const updated_provider_ids = organizationIdps.map(
          provider => provider.id
        );

        const new_providers = organizationIdps
          .filter(provider => !provider.id)
          .map(provider => {
            return {
              identityProvider: provider.identityProvider,
              key: provider.key,
              organizationId: org.id,
            };
          });

        const updated_providers = organizationIdps
          .filter(provider => provider.id)
          .map(provider => {
            return {
              id: provider.id,
              identityProvider: provider.identityProvider,
              key: provider.key,
              organizationId: org.id,
            };
          });

        const deleted_providers = existing_provider_ids.filter(
          id => !updated_provider_ids.includes(id)
        );

        if (new_providers.length) {
          await api.createOrg({ organizationIdps: new_providers });
        }

        if (updated_providers.length) {
          await asyncForEach(updated_providers, async organizationIdp => {
            await api.updateOrg({ organizationIdp });
          });
        }

        if (deleted_providers.length) {
          await api.deleteOrg({ organizationIdps: deleted_providers });
        }

        context.dispatch('getAllOrgs');
        context.dispatch('getCurrencies');
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  deleteOrg(context, data) {
    return new Promise(async (resolve, reject) => {
      try {
        await api.deleteOrg(data);
        context.dispatch('getAllOrgs');
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  uploadFile(context, { file, org }) {
    return new Promise((resolve, reject) => {
      const loginKey = `cognito-idp.eu-west-2.amazonaws.com/${env.UserPoolId}`;
      const Logins = {};
      Logins[loginKey] = context.getters.id_token;

      const region = 'eu-west-2';

      AWS.config.region = region;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: env.IdentityPoolId,
        Logins,
      });

      const Bucket = 'acada-client-logos';
      const extIndex = file.name.lastIndexOf('.');
      const ext = file.name.substr(extIndex);
      const Key = (
        org.orgName.replace(/ /g, '') +
        '_' +
        Date.now() +
        ext
      ).toLowerCase();
      const Body = file;

      const s3 = new AWS.S3({
        region,
        apiVersion: '2006-03-01',
        params: { Bucket },
      });
      const s3Params = {
        Key,
        Body,
        ACL: 'public-read',
        ContentType: file.type,
      };

      s3.putObject(s3Params, (err, data) => {
        if (err) {
          console.log(err);
          reject(err);
        } else {
          resolve(`https://s3.${region}.amazonaws.com/${Bucket}/${Key}`);
        }
      });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
